import React from 'react';
import TailanTt02 from './tt02';

const PageList = () => <TailanTt02 />;

export default PageList;
